<template>
    <v-app-bar color="header" density="comfortable" class="horizontal reader preview" flat>
        <span id="preview-mode" style="display: none">&nbsp;</span>
        <span id="preview-contents" style="display: none">&nbsp;</span>
        <span v-if="viewer === 'teacher'" id="teacher-preview-mode" style="display: none">{{ bookId }}</span>
        <div style="margin: 0 auto">
            <div class="grid no-gutters">
                <div class="unit d-flex align-center position-relative">
                    <a class="home" @click="goBack">
                        <i class="icon icon-giglets"></i>
                        <span class="logo-text">giglets</span>
                    </a>

                    <a id="contents" class="contents" href="">
                        <i class="fa fa-list-ol"></i>
                        <span class="title">Contents</span>
                    </a>

                    <a id="textstyle" class="style" href="">
                        <span class="font-size-icon">
                            <i class="small fa fa-font"></i>
                            <i class="large fa fa-font"></i>
                        </span>
                        <span class="title">Size</span>
                    </a>

                    <template v-if="viewer === 'teacher'">
                        <a id="bgselect" class="style" href="">
                            <i class="fa fa-paint-brush"></i>
                            <span class="title">Colour</span>
                        </a>
                        <ul id="colours" class="submenu colour-dropdown" style="display: none">
                            <li><a href="#ffffff">White</a></li>
                            <li><a href="#f2f2f2">Ivory</a></li>
                            <li><a href="#d8d8d8">Grey</a></li>
                            <li><a href="#ceecf5">Blue</a></li>
                            <li><a href="#f6cece">Pink</a></li>
                            <li><a href="#fee2a9">Yellow</a></li>
                            <li><a href="#f5ecce">Sepia</a></li>
                            <li><a href="#d499ff">Purple</a></li>
                            <li><a href="#000000#ffffff">Black / White</a></li>
                            <li><a href="#000000#ffff00">Black / Yellow</a></li>
                        </ul>
                    </template>

                    <template v-if="viewer === 'teacher'">
                        <a id="printsection" class="style" href="#"
                            ><i class="fa fa-print"></i><span class="title">Print this section</span></a
                        >

                        <template v-if="hasPrem">
                            <a id="highlight_colour" href="#"><i class="fa fa-highlighter"></i>Shared highlighting</a>
                            <div class="dropdown" id="highlight_colours" style="display: none">
                                <ul>
                                    <li class="green">
                                        <a href="#green"><i class="fa fa-highlighter"></i>Green</a>
                                    </li>
                                    <li class="pink">
                                        <a href="#pink"><i class="fa fa-highlighter"></i>Pink</a>
                                    </li>
                                    <li class="yellow">
                                        <a href="#yellow"><i class="fa fa-highlighter"></i>Yellow</a>
                                    </li>
                                    <li class="cyan">
                                        <a href="#cyan"><i class="fa fa-highlighter"></i>Cyan</a>
                                    </li>
                                    <li class="magenta">
                                        <a href="#magenta"><i class="fa fa-highlighter"></i>Magenta</a>
                                    </li>
                                    <li class="none">
                                        <a href="#"><i class="fa fa-highlighter"></i>Clear highlight</a>
                                    </li>
                                </ul>
                            </div>
                        </template>
                        <template v-else>
                            <a id="" class="help ml-0" href="/tlc-upgrade"
                                ><i class="fa fa-highlighter"></i>Shared highlighting
                                <i class="fa fa-lock featurelock" aria-hidden="true"></i
                            ></a>
                        </template>
                    </template>

                    <template v-if="viewer === 'staff'">
                        <a class="help" @click="editSection"> <i class="fa fa-pencil"></i>Edit this section </a>
                        <RouterLink class="help" :to="`/staff/book/${bookId}/edit-book`">
                            <i class="fa fa-home"></i>Back to content overview
                        </RouterLink>
                    </template>

                    <a id="audioreveal" class="pull-right" href="#"><i class="fa fa-volume-up">&nbsp;</i></a>
                    <div id="audioplayer_container" style="display: none">
                        <audio id="audioplayer" controls>
                            <source id="audiosource" src="" type="audio/mpeg" />
                        </audio>
                    </div>
                </div>
            </div>
        </div>
    </v-app-bar>
</template>

<script setup lang="ts">
const props = defineProps<{
    viewer: string;
    bookId: number;
}>();

const router = useRouter();

const hasPrem = ref(false);
if (props.viewer === 'teacher') {
    const store = useTeacherStore();
    const school = await store.fetchSchool();
    hasPrem.value = school.value.type.abbrv === 'PREM';
}

function goBack() {
    if (props.viewer === 'staff') {
        router.push(`/staff/book/${props.bookId}/edit-book`);
    } else {
        router.push(`/teacher/book/${props.bookId}/about`);
    }
}

function editSection() {
    const w = window as any;
    const section = w.reader.sections[w.reader.section];
    router.push(`/staff/book/${props.bookId}/section/${section}`);
}
</script>
<style lang="scss" scoped>
:deep(.v-toolbar__content) {
    overflow: visible;
}

.font-size-icon {
    position: relative !important;
    max-width: 24px !important;
    overflow: visible !important;

    .small {
        left: 15px !important;
        font-size: 18px !important;
    }

    .large {
        font-size: 24px !important;
    }
}

.toggle:hover i {
    color: #fff;
    background: transparent;
}

.horizontal .wrap {
    padding: 0 20px;
}

.horizontal .help,
.horizontal .books,
.horizontal .messages,
.horizontal .help {
    text-decoration: none;
    margin: 0 25px 0 0;
    padding: 0;
    color: #fff;
    text-align: left;
    font-size: 16px;
    font-family: HeinemannSpecial-Bold;
}

body.od .horizontal .help,
body.od .horizontal .books,
body.od .horizontal .messages,
body.od .horizontal .help {
    font-family: open-dyslexic-bold;
}

.horizontal .help {
    margin-top: 0;
    position: relative;
    margin-left: 10px;
}

.horizontal .contents,
.horizontal .ws,
.horizontal #highlight_colour,
.horizontal .style {
    text-decoration: none;
    margin: 0 25px 0 0;
    padding: 0;
    color: #fff;
    text-align: left;
    font-size: 16px;
    font-family: HeinemannSpecial-Bold;
}

body.od .horizontal .style {
    font-family: open-dyslexic-bold;
}

.horizontal i {
    color: #008fd5;
    opacity: 1;
    font-size: 32px;
    display: inline-block;
    position: relative;
    top: 8px;
    margin: 0 8px 0 0;
}

.horizontal i.fa {
    top: 4px;
    font-size: 24px;
}

.horizontal span.title {
    color: #fff;
}

.horizontal a:hover i {
    color: #fff;
}

.horizontal .contents i,
.horizontal .help i {
    left: 3px;
}

.horizontal .home {
    text-decoration: none;
    margin-right: 30px;
    padding: 0;
    color: #47585e;
    text-align: left;
}

body.od .horizontal .home {
    font-family: open-dyslexic-bold;
}

.horizontal .home i {
    font-size: 32px;
    margin-right: 8px;
    position: relative;
    top: 8px;
}

.horizontal .home span.logo-text {
    font-size: 26px;
    color: #fff;
    font-family: HeinemannSpecial-Bold;
}

.horizontal .probtn {
    color: #fff;
    background: #263033;
    margin: 9px 0 0 0;
}

.horizontal .user img {
    width: 21px;
    margin: 0 10px 0 0;
    display: block;
    float: left;
}

.horizontal .user .title {
    margin-top: 7px;
    display: inline-block;
}

.horizontal #header_pupil_span.title {
    max-width: 200px;
}

.horizontal div.search {
    float: right;
    margin: 9px 0 0 0;
}

.horizontal div.search input[type='text'] {
    color: #c4cacc;
    outline: none;
    width: 210px;
    border: 0;
    background: #13181a;
    padding: 6px 10px 2px 10px;
    border-radius: 3px;
}

.horizontal i.featurelock {
    color: #d00000;
    font-size: 18px !important;
    top: 1px !important;
    margin-left: 0;
    display: inline-block;
}

.horizontal a#highlight_colour_upgrade i.featurelock {
    top: 9px !important;
}
</style>

<style lang="scss">
ul#toc {
    top: 44px;
    position: absolute;
    background: #263033;
    margin: 0;
    min-width: 200px;
    z-index: 1001;
    border-top: 0;
    padding: 9px 0;
    border-radius: 0;
    color: #333 !important;
    list-style-type: none;
}

ul#toc li a {
    display: block;
    font-size: 16px;
    line-height: 21px;
    text-decoration: none;
    text-align: left;
    margin: 0;
    color: #fff !important;
    padding: 3px 24px 3px 18px;
}

ul#toc li a:hover {
    background: #008fd5;
}

ul.submenu {
    top: 44px;
    position: absolute;
    background: #263033;
    margin: 0;
    min-width: 200px;
    z-index: 1001;
    border-top: 0;
    padding: 9px 0;
    border-radius: 0;
    color: #fff !important;
    list-style-type: none;
}

ul.submenu li a {
    display: block;
    font-size: 16px;
    line-height: 21px;
    text-decoration: none;
    text-align: left;
    margin: 0;
    color: #fff !important;
    padding: 3px 24px 3px 18px;
}

ul.submenu li a:hover {
    background: #7e7e7e;
}

div.dropdown {
    position: absolute;
    min-width: 200px;
    z-index: 1001;
    left: 0;
    top: 33px;
    background-color: #263033;
    border-top: 0;
    box-shadow: none;
    padding: 9px 0;
    border-radius: 0;
}

div.dropdown ul {
    margin: 3px 0;
    padding: 0;
}

div.dropdown li {
    margin: 0;
    padding: 0;
    display: block;
}

div.dropdown li a {
    display: block;
    font-size: 16px;
    line-height: 21px;
    text-decoration: none;
    text-align: left;
    margin: 0;
    color: #fff !important;
    padding: 3px 24px 3px 18px;
}

div.dropdown a:hover {
    background: #008fd5;
}
</style>
